import { useRootSelector } from './selector.hook';
import { getToken } from '@/utils/common';

// UI gating only. Every API also enforces these permissions server-side.
export function useShareCardPermissions() {
  const token = useRootSelector((s) => s.auth.token) || getToken();
  let permissions: string[] = [];
  try {
    const segment = token?.split('.')[1];
    if (segment) {
      const base64 = segment.replace(/-/g, '+').replace(/_/g, '/');
      const payload: { perm?: string | string[] } = JSON.parse(atob(base64.padEnd(Math.ceil(base64.length / 4) * 4, '=')));
      const raw = payload.perm;
      permissions = Array.isArray(raw) ? raw : raw?.trimStart().startsWith('[') ? JSON.parse(raw) : raw ? [raw] : [];
    }
  } catch { /* Invalid or absent claims must never grant UI access. */ }
  const has = (code: string) => permissions.some((p) => typeof p === 'string' && p.toLowerCase() === code.toLowerCase());
  return { canInitialize: has('Role.Update'), canView: has('ShareCard.View'), canViewFunding: has('ShareCard.View') && has('ShareCard.Funding.View'),
    canViewAudit: has('ShareCard.View') && has('ShareCard.Audit.View'),
    canRename: has('ShareCard.Update'), canSetVisibility: has('ShareCard.Visibility.Update'),
    canSetStatus: has('ShareCard.Status.Update'), canSync: has('ShareCard.Sync'),
    canViewAlerts: has('ShareCard.Alerts.View') && has('ShareCard.Provisioning.View'),
    canViewProvisioning: has('ShareCard.Provisioning.View'), canRecoverProvisioning: has('ShareCard.Provisioning.View') && has('ShareCard.Provisioning.Recover'),
    canUpdateLimits: has('ShareCard.Limits.Update'), canRecharge: has('ShareCard.Funding.View') && has('ShareCard.Funding.Recharge'),
    canWithdraw: has('ShareCard.Funding.View') && has('ShareCard.Funding.Withdraw'),
    canRecoverFunding: has('ShareCard.Funding.View') && has('ShareCard.Funding.Recover'),
    canReconcileFunding: has('ShareCard.Funding.View') && has('ShareCard.Funding.Reconcile') };
}
